import { Model } from './model';
import {ActionModel} from './action-model'
import { WebobjectMock } from '../DataStore/Mock/webobject-mock';
import { WebObjectModel } from './web-object-model';
export class CTVModel implements Model {

  name: string;
  commandSteps_id: number;
  _id: string;
  command:ActionModel;
  target:WebObjectModel;
  target2:WebObjectModel;
  value: String;
  english_description?: string;
  value1?:any;
  value2?:any;
  seq_no:number=0;
  deleted:number=0;
  _type = "CTV";
  value1SecureMode:boolean=false;
  value2SecureMode:boolean=false;
  errors:any={};
  warnings:any={};
  type: String;
  active?: boolean = true; // Default to true if not specified
}
